import React, { createContext, useContext, ReactNode } from 'react'

export interface WidgetPreviewContextValue {
	isPreview: boolean
	cellSize: number
}

const WidgetPreviewContext = createContext<WidgetPreviewContextValue>({
	isPreview: false,
	cellSize: 168,
})

export const WidgetPreviewProvider: React.FC<{
	isPreview: boolean
	cellSize?: number
	children: ReactNode
}> = ({ isPreview, cellSize = 168, children }) => (
	<WidgetPreviewContext.Provider value={{ isPreview, cellSize }}>
		{children}
	</WidgetPreviewContext.Provider>
)

export const useWidgetPreview = () => useContext(WidgetPreviewContext)
